import apiURL from "@/apiURL";
import { DocumentArrowDownIcon } from "@/icons/solid";

export default function DownloadAllowanceTemplate({ small }) {
	return (
		<a
			className="btn btn-default"
			style={{ display: "block" }}
			title={small ? "Download Template" : undefined}
			target="_blank"
			href={`${apiURL}/settings/upload/payrollAllowances/template`}
		>
			<DocumentArrowDownIcon
				className="h-7 w-7"
				style={{
					display: "inline",
					verticalAlign: "text-top",
				}}
			/>
			{small ? null : <>&nbsp; Download Template</>}
		</a>
	);
}
